import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Pagination } from 'react-bootstrap';
import "../../../assets/css/customer/blog/BlogPage.css";
import AppContext from '../../../context/AppContext';
import axios from 'axios';

const BlogPage = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const navigate = useNavigate();

  const [blgPosts, setBlgPosts] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [blgSearch, setBlgSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 3;

  const viewAllBlogs = () => {
    setPageLoading(true);
    axios
      .get(`${baseUrl}/blogs/viewAllBlogs`)
      .then((res) => {
        console.log("*********log from public blogs", res.data);
        const mapped = res.data.data.map((b) => ({
          id: b.id,
          title: b.title,
          excerpt: b.Excerpt,
          content: b.content,
          category: b.category,
          date: b.date,
          author: b.author,
          image: `${baseUrlForFile}/${b.image}`,
        }));
        setBlgPosts(mapped);
      })
      .catch((err) => { console.log(err) })
      .finally(() => setPageLoading(false));
  };

  useEffect(() => {
    viewAllBlogs();
  }, []);

  // ── Sidebar Data (static for now) ──
  const blgRecentPosts = [
    {
      title: "Capturing 2017 Wedding Moments and the Joy...",
      date: "May 7, 2018",
      image: "https://images.unsplash.com/photo-1524863479829-916d8e77f114?w=150&q=80",
    },
    {
      title: "Creative People make the Best Wedding Photographers",
      date: "May 7, 2018",
      image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=150&q=80",
    },
    {
      title: "Destination Weddings: Live, Love, and Dream Big",
      date: "May 7, 2018",
      image: "https://images.unsplash.com/photo-1460978812857-470ed1c77af0?w=150&q=80",
    },
    {
      title: "Destination Weddings can be the Best Weddings Photo",
      date: "May 7, 2018",
      image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=150&q=80",
    },
  ];

  const blgArchives = [
    { name: "May 2018", count: 2 },
    { name: "April 2018", count: 4 },
    { name: "March 2018", count: 3 },
    { name: "February 2018", count: 5 },
  ];

  const blgCategories = [
    { name: "Destination Weddings", count: 4 },
    { name: "Fashion & Beauty", count: 6 },
    { name: "Food & Drinks", count: 3 },
    { name: "Friendly Weddings", count: 8 },
  ];

  // Filter posts by search
  const blgFiltered = blgPosts.filter((p) =>
    p.title.toLowerCase().includes(blgSearch.toLowerCase())
  );

  // Calculate pagination
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blgFiltered.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(blgFiltered.length / postsPerPage);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="blg-root">
      {/* ── Hero ── */}
      <div className="blg-hero">
        <img
          src="https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=1400&q=80"
          alt="Wedding Blog Hero"
          className="blg-hero-img"
        />
        <div className="blg-hero-overlay">
          <p className="blg-hero-script">Welcome to</p>
          <h1 className="blg-hero-title">Our Blog</h1>
          <p className="blg-hero-sub">Stories · Inspiration · Love</p>
        </div>
      </div>

      <div className="blg-page">
        <div className="blg-layout">
          {/* ══════════════════
              MAIN POSTS
          ══════════════════ */}
          <main>
            {pageLoading && <p>Loading...</p>}

            {!pageLoading && currentPosts.length === 0 && (
              <p>No blog posts found.</p>
            )}

            <div className="blg-posts-list">
              {currentPosts.map((post, i) => (
                <article
                  key={post.id}
                  className="blg-post-card"
                  style={{ animationDelay: `${i * 0.08}s` }}
                >
                  {/* Image */}
                  <div className="blg-post-img-wrap">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="blg-post-img"
                    />
                    <span className="blg-post-category-tag">
                      {post.category}
                    </span>
                  </div>

                  {/* Body */}
                  <div className="blg-post-body">
                    <div className="blg-post-meta">
                      <span className="blg-meta-item">{post.date}</span>
                      <span className="blg-meta-dot" />
                      <span className="blg-meta-item">{post.category}</span>
                      <span className="blg-meta-dot" />
                      <span className="blg-meta-item">{post.author}</span>
                    </div>

                    <h2 className="blg-post-title">{post.title}</h2>
                    <div className="blg-divider" />
                    <p className="blg-post-excerpt">{post.excerpt}</p>

                    <div className="blg-post-footer">
                      <button
                        className="blg-read-more"
                        onClick={() => navigate(`/blogs/${post.id}`)}
                      >
                        Read More
                        <span className="blg-read-more-arrow">→</span>
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {/* Load More Button */}
            {currentPage < totalPages && (
              <div className="blg-load-more-wrapper">
                <button
                  className="blg-load-more-btn"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Load More
                  <span className="blg-load-more-icon">↓</span>
                </button>
              </div>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="blg-pagination-wrapper">
                <Pagination className="blg-pagination">
                  <Pagination.Prev
                    onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                  />

                  {[...Array(totalPages)].map((_, index) => (
                    <Pagination.Item
                      key={index + 1}
                      active={index + 1 === currentPage}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}

                  <Pagination.Next
                    onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            )}
          </main>

          {/* ══════════════════
              SIDEBAR
          ══════════════════ */}
          <aside className="blg-sidebar">

            {/* Featured Photo */}
            <img
              src="https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?w=600&q=80"
              alt="Featured"
              className="blg-featured-img-widget"
            />

            {/* Search */}
            <div className="blg-widget">
              <div className="blg-widget-head">
                <h3 className="blg-widget-title">Search It</h3>
              </div>
              <div className="blg-widget-body">
                <div className="blg-search-form">
                  <input
                    type="text"
                    className="blg-search-input"
                    placeholder="Search posts..."
                    value={blgSearch}
                    onChange={(e) => setBlgSearch(e.target.value)}
                  />
                  <button className="blg-search-btn">🔍</button>
                </div>
              </div>
            </div>

            {/* Recent Posts */}
            <div className="blg-widget">
              <div className="blg-widget-head">
                <h3 className="blg-widget-title">Recent Posts</h3>
              </div>
              <div className="blg-widget-body">
                {blgRecentPosts.map((rp, i) => (
                  <div key={i} className="blg-recent-post">
                    <img
                      src={rp.image}
                      alt={rp.title}
                      className="blg-recent-thumb"
                    />
                    <div className="blg-recent-info">
                      <p className="blg-recent-title">{rp.title}</p>
                      <p className="blg-recent-date">{rp.date}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Featured Photo 2 */}
            <img
              src="https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=600&q=80"
              alt="Featured"
              className="blg-featured-img-widget"
            />

            {/* Archives */}
            <div className="blg-widget">
              <div className="blg-widget-head">
                <h3 className="blg-widget-title">Archives</h3>
              </div>
              <div className="blg-widget-body">
                <ul className="blg-archive-list">
                  {blgArchives.map((a, i) => (
                    <li key={i} className="blg-archive-item">
                      <span className="blg-archive-name">
                        <span className="blg-archive-arrow">›</span>
                        {a.name}
                      </span>
                      <span className="blg-archive-count">{a.count}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Categories */}
            <div className="blg-widget">
              <div className="blg-widget-head">
                <h3 className="blg-widget-title">Categories</h3>
              </div>
              <div className="blg-widget-body">
                <ul className="blg-cat-list">
                  {blgCategories.map((cat, i) => (
                    <li key={i} className="blg-cat-item">
                      <span className="blg-cat-name">
                        <span className="blg-cat-dot" />
                        {cat.name}
                      </span>
                      <span className="blg-cat-count">{cat.count}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;